import { render, staticRenderFns } from "./CProcessRatingListCards.vue?vue&type=template&id=11b9cbb6&"
import script from "./CProcessRatingListCards.vue?vue&type=script&lang=js&"
export * from "./CProcessRatingListCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports